export const hasDamageOptions = [
  { label: 'Без урона', value: 0 },
  { label: 'С повреждениями', value: 1 },
  { label: 'Неважно', value: '' },
];
